import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { DesignAngularKitModule } from 'design-angular-kit';
import { AuthService } from '../../services/auth.service';
import { ContextService } from '../../services/context.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, RouterLink, RouterLinkActive],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  constructor(
    public authService: AuthService,
    public contextService: ContextService,
    private router: Router
  ) {}

  goToContext(event: any) {
    event.preventDefault();
    this.router.navigate(['/context']);
  }

  logout() {
    this.authService.logout();
  }
}
